import UserProfileApi from '../api/userProfileApi';
import UserProfileData from '../types/userProfileData';
import { User } from 'firebase/auth';

export class UserProfileService {
  static async getUserProfilesAsMap() {
    const userProfiles = await UserProfileApi.getUserProfiles();
    const userProfileMap = new Map<string, UserProfileData>();
    userProfiles.forEach(userProfile => {
      userProfileMap.set(userProfile.uuid, userProfile);
    });
    return userProfileMap;
  }

  static async getUserProfilesFromUuids(uuids: string[]) {
    const userProfileMap = await this.getUserProfilesAsMap();
    return uuids.map(uuid => {
      const userProfile = userProfileMap.get(uuid);
      if (!userProfile) {
        throw new Error('User profile could not be found');
      }
      return userProfile;
    });
  }

  static async isModerator(user: User | null) {
    if (!user) return false;
    const userProfile = await UserProfileApi.getUserProfileByUuid(user.uid);
    return userProfile !== null && userProfile.role === 'MODERATOR';
  }
}
